var _excluded = ["children"];
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import './style.scss';
var DefaultMenuItem = function DefaultMenuItem(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("li", props, children);
};
var InlineMenu = function InlineMenu(_ref2) {
  var _ref2$autoFill = _ref2.autoFill,
    autoFill = _ref2$autoFill === void 0 ? false : _ref2$autoFill,
    targetRef = _ref2.targetRef,
    items = _ref2.items,
    scrollToTopOffset = _ref2.scrollToTopOffset,
    _ref2$MenuItemElement = _ref2.MenuItemElement,
    MenuItemElement = _ref2$MenuItemElement === void 0 ? DefaultMenuItem : _ref2$MenuItemElement;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    scrollPosition = _useState2[0],
    setScrollPosition = _useState2[1];
  var _useState3 = useState(items || []),
    _useState4 = _slicedToArray(_useState3, 2),
    menuItems = _useState4[0],
    setMenuItems = _useState4[1];
  var _useState5 = useState(),
    _useState6 = _slicedToArray(_useState5, 2),
    targetContainer = _useState6[0],
    setTargetContainer = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    autoFilled = _useState8[0],
    setAutoFilled = _useState8[1];
  var handleScroll = function handleScroll() {
    var position = window.pageYOffset;
    setScrollPosition(position);
  };

  /**
   * Get the depth of the headers in the inline menu based on the tagName
   * @param {HTMLElement} headerElement - The element we are getting the depth of
   * @returns {number} - The header depth as an integer
   */
  var getHeaderDepth = function getHeaderDepth(headerElement) {
    switch (headerElement.tagName) {
      case 'H5':
        return 4;
      case 'H4':
        return 3;
      case 'H3':
        return 2;
      case 'H2':
        return 1;
      case 'H1':
      default:
        return 0;
    }
  };

  /**
   * If autoFill is enabled, and the menu has not been filled yet
   * Get all header items in the target container, provide them with an id if required
   * And add them to the items list
   * @returns {void}
   */
  var generateMenuItems = useCallback(function () {
    if (targetContainer && autoFill && !autoFilled) {
      var allHeaderElements = targetContainer.querySelectorAll('h1, h2, h3, h4, h5');
      var itemsList = items && items.length ? items : [];
      allHeaderElements.forEach(function (headerElement) {
        // Generate Id if not there
        if (!headerElement.id) {
          headerElement.setAttribute('id', headerElement.innerHTML.normalize().replace(/[^A-Z0-9]/ig, '_').trim());
        }
        itemsList.push({
          depth: getHeaderDepth(headerElement),
          menuItemName: headerElement.innerHTML,
          elementId: headerElement.id,
          activeByDefault: false
        });
      });
      setMenuItems(itemsList);
      setAutoFilled(true);
    }
  }, [targetContainer]);

  /**
   * Get the offset from the top for an element
   * @param {HTMLElement} element - The element to get the offset of
   * @returns {object} - An object containing the top and left offset relative to the passed element
   */
  var offset = function offset(element) {
    var rect = element.getBoundingClientRect();
    var scrollLeft = window.pageXOffset || targetContainer.scrollLeft;
    var scrollTop = window.pageYOffset || targetContainer.scrollTop;
    return {
      top: rect.top + scrollTop,
      left: rect.left + scrollLeft
    };
  };

  /**
   * On click, scroll to the corresponding item in the targetContainer
   * @param {string} id - The id of the items that was clicked
   * @returns {void}
   */
  var handleClick = function handleClick(id) {
    if (targetContainer) {
      var element = targetContainer.querySelector("#".concat(id));
      if (!element) return null;
      window.scrollTo({
        top: offset(element).top - scrollToTopOffset,
        behavior: 'smooth'
      });
    }
  };

  /**
   *  Returns if the element with currentId is currently in its active state based on its offset from top
   * @param {string} currentId - The id of the element were checking the active state of
   * @param {string} nextId - The element that comes after in the list
   * @param {boolean} activeByDefault - If the element should be active by default if there are no elements yet
   * @returns {boolean} - If the element with currentId is active
   */
  var handleActiveState = function handleActiveState(currentId, nextId, activeByDefault) {
    if (targetContainer) {
      var element = targetContainer.querySelector("#".concat(currentId));
      var nextElement = targetContainer.querySelector("#".concat(nextId));
      if (!element && activeByDefault) return true;
      if (!element) return null;
      if (!nextElement) {
        return scrollPosition > offset(element).top - (scrollToTopOffset + 10);
      } else {
        return (scrollPosition > offset(element).top - (scrollToTopOffset + 10) || activeByDefault) && scrollPosition < offset(nextElement).top - (scrollToTopOffset + 10);
      }
    }
    return null;
  };
  useEffect(function () {
    window.addEventListener('scroll', handleScroll);
    return function () {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  useEffect(function () {
    setTargetContainer(targetRef && targetRef.current ? targetRef.current : document.documentElement);
  }, [targetRef]);
  useEffect(function () {
    generateMenuItems();
  }, [targetContainer, generateMenuItems]);
  if (!items && !autoFill) return null;
  return /*#__PURE__*/React.createElement("nav", {
    className: "InlineMenu"
  }, /*#__PURE__*/React.createElement("ul", {
    className: "InlineMenu__nav"
  }, menuItems.map(function (_ref3, index, elements) {
    var _ref3$depth = _ref3.depth,
      depth = _ref3$depth === void 0 ? 0 : _ref3$depth,
      menuItemName = _ref3.menuItemName,
      elementId = _ref3.elementId,
      activeByDefault = _ref3.activeByDefault;
    return /*#__PURE__*/React.createElement(MenuItemElement, {
      className: "InlineMenu__nav-item depth-".concat(depth, " ").concat(handleActiveState(elementId, elements[index + 1] && elements[index + 1].elementId, activeByDefault) && 'is-active'),
      onClick: function onClick() {
        return handleClick(elementId);
      },
      key: elementId
    }, menuItemName || 'missing menuItemName');
  })));
};
InlineMenu.defaultProps = {
  autoFill: false,
  targetRef: null,
  items: null,
  scrollToTopOffset: 0,
  MenuItemElement: DefaultMenuItem
};
InlineMenu.propTypes = {
  autoFill: PropTypes.bool,
  targetRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.element
  })]),
  items: PropTypes.arrayOf(PropTypes.shape({
    menuItemName: PropTypes.string.isRequired,
    elementId: PropTypes.string.isRequired,
    activeByDefault: PropTypes.bool,
    depth: PropTypes.number
  })),
  scrollToTopOffset: PropTypes.number,
  MenuItemElement: PropTypes.element
};
export default InlineMenu;